import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyDirective } from './lazy/lazy.directive';

@Component({
  selector: 'app-component-loader',
  standalone: true,
  imports: [CommonModule, LazyDirective],
  templateUrl: './component-loader.component.html',
  styleUrls: ['./component-loader.component.scss']
})
export class ComponentLoader implements OnChanges {

  @Input() load: boolean = false;
  @Input() selector: string = '';
  @Input() inputs: any;
  @Input() outputs: any;

  lazy_config: any;

  ngOnChanges(changes: SimpleChanges): void {
    if ((!changes?.['load']?.currentValue) || (changes?.['load']?.currentValue === changes?.['load']?.previousValue) || (changes?.['load']?.currentValue?.toString() === changes?.['load']?.previousValue?.toString())) {
      return;
    }
    this.loadLazyComponent();
  }

  loadLazyComponent() {
    if (!this.load) {
      return;
    }
    this.lazy_config = {
      component: this.getPath()
    }

  }

  getPath() {

    switch (true) {
      case this.selector === 'app-home-v2':
        return () => import('./../home-v2/home-v2.component');

      case this.selector === 'app-dm-campaign-select':
        return () => import('./../dm-campaign-select/dm-campaign-select.component');

      case this.selector === 'app-tax-benefit-nudge':
        return () => import('./../tax-benefit-nudge/tax-benefit-nudge.component');

      case this.selector === 'app-medibuddy-typ':
        return () => import('./../medibuddy-typ/medibuddy-typ.component');

      case this.selector === 'app-download-banner':
        return () => import('./../download-banner/download-banner.component');

      case this.selector === 'app-hf-mini-dialog':
        return () => import('./../hf-mini-dialog/hf-mini-dialog.component');

      case this.selector === 'app-hf-mini-typ':
        return () => import('./../hf-mini-typ/hf-mini-typ.component');

      case this.selector === 'app-hf-mini-pitch':
        return () => import('./../hf-mini-pitch/hf-mini-pitch.component');

      case this.selector === 'app-otd-price-breakdown':
        return () => import('./../otd-price-breakdown/otd-price-breakdown.component');

      case this.selector === 'app-thankyou-sucess-head-v2':
        return () => import('./../thankyou-sucess-head-v2/thankyou-sucess-head-v2.component');

      case this.selector === 'app-sip-pitch-card-v5':
        return () => import('./..//sip-pitch-card-v5/sip-pitch-card-v5.component');

      case this.selector === 'app-multicause-sip-v2':
        return () => import('./../multicause-sip-v2/multicause-sip-v2.component');

      case this.selector === 'app-sip-hamburger':
        return () => import('./../sip-hamburger/sip-hamburger.component');

      case this.selector === 'app-home-urgent-banner-v2':
        return () => import('./../home-urgent-banner-v2/home-urgent-banner-v2.component');

      case this.selector === 'app-hf-gift-info-nudge':
        return () => import('./../hf-gift-info-nudge/hf-gift-info-nudge.component');

      case this.selector === 'app-thankyou-min-tip':
        return () => import('./../thankyou-min-tip/thankyou-min-tip.component');

      case this.selector === 'test-vid':
        return () => import('./../test-vid/test-vid.component');

      case this.selector === 'app-gift-redeem-card':
        return () => import('./../gift-redeem-card/gift-redeem-card.component');

      case this.selector === 'app-hf-thankyou-page':
        return () => import('../../health-first/components/hf-thankyou-page/hf-thankyou-page.component');
      default:
        return;
    }

  }

}
